import axios from 'axios';
import { configs } from '../app/app-configs';
import { MealItem, MealItemRequest } from './model/nutrition.model';

export const getMealItems = async (searchTerm: string, category: string): Promise<MealItem[]> => {
    return await axios.get(`${configs.BASE_URL}/meal-items`, {
        params: {
            search: searchTerm,
            category: category
        }
    }).then((res) => {
        return res.data;
    });
};

export const createMealItem = async (
    request: MealItemRequest
): Promise<MealItem> => {
    return await axios
        .post(`${configs.BASE_URL}/meal-items`, request)
        .then((res) => {
            return res.data as MealItem;
        });
};

export const updateMealItem = async (
    request: MealItemRequest
): Promise<MealItem> => {
    return await axios
        .put(`${configs.BASE_URL}/meal-items/${request.id}`, request)
        .then((res) => {
            return res.data as MealItem;
        });
};

export const deleteMealItem = async (id: number): Promise<number> => {
    return await axios
        .delete(`${configs.BASE_URL}/meal-items/${id}`)
        .then((res) => {
            return res.data;
        });
};
